import React from "react";
import Footer from './build/footer/footer';
import Header from './build/header/header';

const LayoutPost = ({ children }) => {

  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default LayoutPost;
